// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1ryZo","info":"Note_info__3mw0v","note":"Note_note__2d_Jw","actions":"Note_actions__10MZp"};